module.exports = __webpack_public_path__ + "static/media/TP21.1774c2c9.jpg";